import type {ParamDefinition} from './ParamDefinition';

export type Content = {
  relatedActions: Array<ParamDefinition> | null;
  additionalInformation: Array<ParamDefinition> | null;
};
